import { UserIdentity } from 'ra-core';
import { AuthProvider } from 'react-admin';
import { getIdentity, isAuthenticated, Login, Logout } from '../../Auth';

export interface LoginToken {
  idToken: string;
}
const GoogleAuthProvider = {
  login: async (loginToken: LoginToken) => {
    console.log('login', loginToken);
    await Login(loginToken.idToken);
    return Promise.resolve();
  },

  logout: async (params: unknown) => {
    console.log('logout', params);
    Logout();
    return Promise.resolve();
  },

  checkAuth: (params: unknown) => {
    console.log('checkAuth', params);
    return isAuthenticated() ? Promise.resolve() : Promise.reject();
  },

  checkError: async (error: unknown) => {
    console.error('checkError', error);
    return Promise.resolve();
  },

  getIdentity: async (): Promise<UserIdentity | null> => {
    console.error('getIdentity');
    return getIdentity();
  },

  getPermissions: async (params: unknown) => {
    console.log('getPermissions', params);
    Promise.resolve();
  }
  //  [key: string]: any;
} as AuthProvider;

export default GoogleAuthProvider;
